import React,{useEffect} from "react";
import { NavLink } from "react-router-dom";
import "../Footer/Footer.css";

function Footer() {
  useEffect(() => {
    var n = new Date();
    var y = n.getFullYear();
    document.getElementById("date").innerHTML = y;
  });
  return (
    <>
      <div className="footer">
        <div className="footer-navlink" >
        <NavLink to="/" className="menu-name">
                Home{" "}
              </NavLink>{" "}
              <NavLink to="/about" className="menu-name">
                About Us{" "}
              </NavLink>
              <NavLink to="/product" className="menu-name">
                Product
              </NavLink>
              <NavLink to="/mdi" className="menu-name">
                MDIs
              </NavLink>
              <NavLink to="/quality" className="menu-name">
                Quality
              </NavLink>
              <NavLink to="/technology" className="menu-name">
                Technology{" "}
              </NavLink>
              <NavLink to="/contact" className="menu-name">
                Contact Us
              </NavLink>
        </div>
        <div className="copy-right"><p>Medisol Lifescience Pvt. Ltd</p>
        <p>© Copyright <span id="date"></span>, All Right Reserved</p></div>
      </div>      
    </>
  );
}
export default Footer;

// Head Office

// 228, Pragati Industrial Estate,
// N. M. Joshi Marg, Lower Parel (E)
// Mumbai, 400 011, India

// Corporate Office

// 1417, Make Chamber V, Nariman Point,
// Mumbai 400 021, India
//   Tel:91-22-69074440/91-22-22831351
// Email: medisol@asianitg.com
